import { h } from './dom.js';

function inline(text: string): Array<string | HTMLElement> {
  return text.replace(/`([^`\n]+)`/g, '$1').split(/\*\*(.+?)\*\*/g).map((part, index) => index % 2 ? h('strong', {}, [part]) : part);
}

/** Model text as DOM: paragraphs, lists and bold only, always through text nodes. Never HTML. */
export function richText(text: string): HTMLElement[] {
  const blocks: HTMLElement[] = [];
  let list: HTMLElement | null = null;
  for (const raw of text.split(/\r?\n/)) {
    const line = raw.trim();
    const bullet = /^[-*•]\s+(.+)$/.exec(line);
    const numbered = /^\d+[.)]\s+(.+)$/.exec(line);
    const item = bullet ?? numbered;
    if (item) {
      const tag = bullet ? 'UL' : 'OL';
      if (list?.tagName !== tag) { list = h(bullet ? 'ul' : 'ol'); blocks.push(list); }
      list.append(h('li', {}, inline(item[1]!)));
      continue;
    }
    list = null;
    if (line) blocks.push(h('p', {}, inline(line)));
  }
  return blocks;
}
